import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["loading", "umbrellaCollection"];
import { parse as parseParams } from 'hub-http/helpers/params';
import { useTrackMarketplaceEvent } from 'marketplace-ui-tracking';
import { getPageViewedEvent } from 'marketplace-ui-tracking/events/marketplace';
import { useEffect, useRef } from 'react';
import { useAppContext } from '../context/AppContext';
export function useTrackUmbrellaCollectionViewedEvent(_ref) {
  let {
      loading,
      umbrellaCollection
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  const appContext = useAppContext();
  const params = parseParams(window.location.search.slice(1));
  const trackMarketplaceEvent = useTrackMarketplaceEvent();
  const eventSentRef = useRef(false);
  useEffect(() => {
    if (!loading && !eventSentRef.current) {
      var _umbrellaCollection$c;
      eventSentRef.current = true;
      const sectionStrings = umbrellaCollection === null || umbrellaCollection === void 0 || (_umbrellaCollection$c = umbrellaCollection.collectionIds) === null || _umbrellaCollection$c === void 0 ? void 0 : _umbrellaCollection$c.map((collectionId, index) => `${index}__${collectionId}`);
      trackMarketplaceEvent(getPageViewedEvent(Object.assign({}, rest, {
        sections: sectionStrings
      })));
    }
  }, [appContext, loading, params, rest, umbrellaCollection, trackMarketplaceEvent]);
}